/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsVerifyMfaToken204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsVerifyMfaToken505Schema = z.any();

export const optionsVerifyMfaTokenMutationResponseSchema = z.lazy(() => optionsVerifyMfaToken204Schema);
